import { Alert, Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { PlatformPage } from "@/components/PlatformPage";
import { ModuleOfferVersionFacts } from "../components/ModuleOfferEditor";
import { useModuleOfferVersion } from "../hooks/useModuleOfferAuthoring";

export function ModuleOfferVersionPage() {
  const { versionId } = useParams<{ versionId: string }>();
  const query = useModuleOfferVersion(versionId);
  return (
    <PlatformPage
      title="Published module offer"
      isLoading={query.isPending}
      actions={
        <Button size="small" component={Link} to="/contracts/module-offers">
          Back to module drafts
        </Button>
      }
    >
      {query.isError ? (
        <Alert severity="warning">
          Published module version unavailable.{" "}
          <Button size="small" onClick={() => void query.refetch()}>
            Retry
          </Button>
        </Alert>
      ) : query.data && query.data.offer_version_id === versionId ? (
        <ModuleOfferVersionFacts version={query.data} />
      ) : null}
    </PlatformPage>
  );
}
